import VueRouter from "vue-router";
import ManagePermissions from "../pages/ManagePermissions";
import Application from "../pages/Application";
import Subscribe from "../pages/Subscribe";
import Feedback from "../pages/Feedback";
import PermissionModel from "../pages/PermissionModel";
import Environments from "../pages/Environments";
import NonCassApplications from "../pages/NonCassApplications";
import DeletedApps from "../pages/DeletedAps.vue";
import OpenPermissionRequest from "../pages/OpenPermissionRequests.vue";
import ManageUsers from "../pages/ManageUsers";
import ResolverDiagnostics from "../pages/ResolverDiagnostics.vue";
import BackgroundJobs from "../pages/BackgroundJobs.vue";
import AuthFailures from "../pages/AuthFailures.vue";
import CreationDiagnostics from "../pages/CreationDiagnostics.vue";
import MaintenanceMode from "../pages/MaintenanceMode.vue";
import SAPAPIDiagnostics from "../pages/SAPAPIDiagnostics.vue";
import Home from "../pages/Home";
import Version from "../pages/Version";
import Login from "../pages/Login";
import Logout from "../pages/Logout";
import navStore from "../navStore";
import { publicPath } from "../../vue.config.js";
import { isMaintenanceModeActive } from "../services/accessGate";

class Router {
  routes = [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout,
    },
    {
      path: "/applications/:applicationid",
      name: "Application",
      component: Application,
    },
    {
      path: "/subscribe/:productid",
      name: "Subscribe",
      component: Subscribe,
    },
    {
      path: "/applications/:applicationid/permissions/:permissionid",
      name: "Permissions",
      component: ManagePermissions,
    },
    {
      path: "/feedback",
      name: "Feedback",
      component: Feedback,
    },
    {
      path: "/version",
      name: "Version",
      component: Version,
    },
    {
      path: "/permissionmodel",
      name: "PermissionModel",
      component: PermissionModel,
    },
    {
      path: "/openpermissionrequest",
      name: "OpenPermissionRequest",
      component: OpenPermissionRequest,
    },
    {
      path: "/environments",
      name: "Environments",
      component: Environments,
    },
    {
      path: "/noncassapplications",
      name: "NonCassApplications",
      component: NonCassApplications,
    },
    {
      path: "/deletedapps",
      name: "DeletedApps",
      component: DeletedApps,
    },
    {
      path: "/manage",
      name: "ManageUsers",
      component: ManageUsers,
    },
    {
      path: "/admin/identity-resolver",
      name: "ResolverDiagnostics",
      component: ResolverDiagnostics,
    },
    {
      path: "/admin/sapapi-status",
      name: "SAPAPIDiagnostics",
      component: SAPAPIDiagnostics,
    },
    {
      path: "/admin/background-jobs",
      name: "BackgroundJobs",
      component: BackgroundJobs,
    },
    {
      path: "/admin/auth-failures",
      name: "AuthFailures",
      component: AuthFailures,
    },
    {
      path: "/admin/creation-diagnostics/:operationId?",
      name: "CreationDiagnostics",
      component: CreationDiagnostics,
    },
    {
      path: "/maintenance",
      name: "MaintenanceMode",
      component: MaintenanceMode,
    },
    { path: "*", redirect: "/" },
  ];
  router = null;
  constructor(vue) {
    console.log("Router constructor");
    this.router = new VueRouter({
      mode: vue.prototype.$drupal ? "abstract" : "history",
      base: vue.prototype.$drupal ? null : publicPath,
      routes: this.routes,
    });
    this.router.beforeEach((to, from, next) => {
      console.log("Router BeforeEach");
      if (vue.prototype.$drupal) {
        console.log("Router Drupal helper");
        var objTo = {};
        objTo.fullPath = window.location.href;
        to = { ...to, ...objTo };
        window.history.pushState(
          "data",
          document.title,
          window.location.origin + window.location.pathname
        );
      }
      if (
        isMaintenanceModeActive() &&
        to.name !== "MaintenanceMode" &&
        to.name !== "Logout" &&
        to.name !== "Login"
      ) {
        next({ name: "MaintenanceMode" });
        return;
      }
      if (!isMaintenanceModeActive() && to.name === "MaintenanceMode") {
        next({ name: "Home" });
        return;
      }
      if (to.name !== "Login" && !vue.prototype.$authService.isUserLoggedIn()) {
        if (to.name === "MaintenanceMode") {
          next();
          return;
        }
        console.log(to);
        console.log("router: saving navTo: " + to.fullPath);
        navStore.commit("navTo", to.fullPath);
        next({ name: "Login" });
      } else {
        const targetPage = to.query.page;
        if (targetPage != undefined || targetPage != null) {
          console.log("parameter navigation: " + targetPage);
        }
        if (targetPage === "subscribe") {
          const id = to.query.id;
          console.log("id: ", id);
          if (id != undefined) {
            this.router.push({
              name: "Subscribe",
              params: { productid: id },
            });
            return;
          }
        }
        if (targetPage === "feedback") {
          this.router.push({ name: "Feedback" });
          return;
        }
        if (targetPage === "version") {
          this.router.push({ name: "Version" });
          return;
        }
        next();
      }
    });
    if (vue.prototype.$drupal) {
      this.router
        .push({
          name: "Home",
        })
        .catch(() => {
          console.log("Something bad happend .. ");
        });
    }
  }
}

var router_instance = null;

export default {
  install: function (vue) {
    console.log("Init Router");
    router_instance = new Router(vue);
  },
  get: function () {
    console.log("Retrieving Router");
    console.log(router_instance);
    return router_instance.router;
  },
};
